import React, { PureComponent } from 'react';
import loc from 'sources/locale/loc';
import ScreensCarousel from './ScreensCarousel';
import styles from './IndexPage.scss';
import InfoCarousel from './InfoCarousel';

export default class IndexPage extends PureComponent {
  state = {
    current: 0,
  };

  scrollEnabled = true;

  increaseCurrent = () => {
    const { current } = this.state;
    this.setState({ current: current + 1 > 3 ? 0 : current + 1 });
  };

  decreaseCurrent = () => {
    const { current } = this.state;
    this.setState({ current: current - 1 < 0 ? 3 : current - 1 });
  };

  componentDidMount() {
    window.addEventListener('wheel', this.handleScrollWindow, {
      passive: false,
    });
    window.addEventListener('scroll', this.handleScrollWindow);
  }

  componentWillUnmount() {
    window.removeEventListener('wheel', this.handleScrollWindow);
    window.removeEventListener('scroll', this.handleScrollWindow);
  }

  handleScrollWindow = e => {
    e.preventDefault();
    e.stopPropagation();
    const isMobileView =
      window && window.matchMedia(`screen and (max-width: ${768}px)`).matches;
    if (!this.scrollEnabled || isMobileView) {
      return;
    }
    const { deltaY, deltaX } = e;

    const delta = Math.abs(deltaY) > Math.abs(deltaX) ? deltaY : deltaX;

    this.scrollEnabled = false;
    setTimeout(() => {
      this.scrollEnabled = true;
    }, 1500);
    if (delta > 0) {
      this.increaseCurrent();
      return;
    }
    this.decreaseCurrent();
  };

  render() {
    return (
      <section
        className={styles.container}
        style={{ height: window.innerHeight - 70 }}
      >
        <div className={styles.titleWrapper}>
          <img
            src={'static/images/question_game.svg'}
            className={styles.title}
            alt="Question game"
          />
        </div>
        <div className={styles.left}>
          <InfoCarousel
            current={this.state.current}
            onSwipe={this.increaseCurrent}
          />
        </div>
        <div className={styles.middle}>
          <ScreensCarousel
            current={this.state.current}
            className={styles.carousel}
          />
        </div>
        <div className={styles.right}>
          <button
            role="button"
            aria-label="scroll"
            className={styles.scroll}
            onClick={this.increaseCurrent}
          >
            <div className={styles.line} />
            {loc('scroll')}
          </button>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IndexPage/IndexPage.jsx